<template>
  <div class="project-square">
    <div class="create-project">
      <span class="title">创建新项目</span>
      <span class="new" @click="newProject">
        <a-icon type="plus" />
        新建项目
      </span>
    </div>
    <div class="project-list">
      <div style="padding:0 24px">
        <div class="title">项目列表</div>
      </div>
      <a-divider style="margin:10px 0 0px 0;color:#F7F7F7"/>
      <div style="clear:both"></div>
      <div style="padding:24px 24px 50px 24px;">
        <a-table id="pro-table" :data-source="data.records" :pagination='false' :loading="ifShowLoading">
          <a-table-column key="name" title="" data-index="name">
            <template slot-scope="text, record">
              <div>
                <span style="color:rgba(102, 102, 102, 1);font-size:16px;font-weight:bold">{{ record.name }}</span>
              </div>
              <div style="margin:20px 0 18px 0">
                <span style="color:rgba(170, 170, 170, 1);font-size:12px;">{{record.description}}</span>
              </div>
              <div style="color:rgba(170, 170, 170, 1);font-size:12px;">
                <span>智能度：</span>
                <span style="margin-right:60px;color:rgba(24, 144, 255, 1)"></span>
                <span>appid：{{record.id}}</span>
              </div>
            </template>
          </a-table-column>
          <a-table-column key="toStartTaskCount" title="" data-index="toStartTaskCount">
            <template slot-scope="text, record">
              <div style="text-align:center">
                <span @click="viewList(record.id,'TO_START')" style="cursor:pointer;color:rgba(255, 141, 26, 1);font-size:20px;font-weight:bold">{{ record.toStartTaskCount }}</span>
              </div>
              <div style="text-align:center">
                <span style="color:rgba(170, 170, 170, 1);font-size:12px;">待领取</span>
              </div>
            </template>
          </a-table-column>
          <a-table-column key="onGogingTaskCount" title="" data-index="onGogingTaskCount">
            <template slot-scope="text, record">
              <div style="text-align:center">
                <span @click="viewList(record.id,'ON_GOING')" style="cursor:pointer;color:rgba(24, 144, 255, 1);font-size:20px;font-weight:bold">{{ record.onGogingTaskCount }}</span>
              </div>
              <div style="text-align:center">
                <span style="color:rgba(170, 170, 170, 1);font-size:12px;">进行中</span>
              </div>
            </template>
          </a-table-column>
          <a-table-column key="toCheckTaskCount" title="" data-index="toCheckTaskCount">
            <template slot-scope="text, record">
              <div style="text-align:center">
                <span @click="viewList(record.id,'TO_CHECK')" style="cursor:pointer;color:rgba(255, 195, 0, 1);font-size:20px;font-weight:bold">{{ record.toCheckTaskCount }}</span>
              </div>
              <div style="text-align:center">
                <span style="color:rgba(170, 170, 170, 1);font-size:12px;">待验收</span>
              </div>
            </template>
          </a-table-column>
          <a-table-column key="finishTaskCount" title="" data-index="finishTaskCount">
            <template slot-scope="text, record">
              <div style="text-align:center">
                <span @click="viewList(record.id,'FINISH')" style="cursor:pointer;color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold">{{ record.finishTaskCount }}</span>
              </div>
              <div style="text-align:center">
                <span style="color:rgba(170, 170, 170, 1);font-size:12px;">已结束</span>
              </div>
            </template>
          </a-table-column>
          <a-table-column key="delayTaskCount" title="" data-index="delayTaskCount">
            <template slot-scope="text, record">
              <div style="text-align:center">
                <span @click="createTask(record.id)" style="cursor:pointer;display:inline-block;width:80px;height:28px;line-height:28px;background:rgba(24, 144, 255, 1);border-radius:4px;color:#fff;font-size:14px;">新建任务</span>
              </div>
              <div style="text-align:center">
                <span @click="viewList(record.id,'DELAY')" style="cursor:pointer;color:rgba(255, 70, 70, 1);font-size:20px;font-weight:bold">{{ record.delayTaskCount }}</span>
              </div>
              <div style="text-align:center">
                <span style="color:rgba(170, 170, 170, 1);font-size:12px;">已延期</span>
              </div>
            </template>
          </a-table-column>
        </a-table>
        <div style="font-size:14px;margin-top:16px;float:left">
          <span style="color:rgba(80, 80, 80, 1)">总计：</span>
          <span style="color:rgba(24, 144, 255, 1)">{{data.total}}个</span>
        </div>
        <a-pagination
          style="float:right;margin-top:16px"
          v-model="currentPage"
          :page-size-options="pageSizeOptions"
          :total="data.total"
          show-size-changer
          :page-size="pageSize"
          @showSizeChange="onShowSizeChange"
          @change="onChangeSample"
        >
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
          </template>
        </a-pagination>
      </div>
    </div>
    <a-modal v-model="visiblePro" title="新建项目" :footer='null' :maskClosable='false'>
      <div>
        <div>
          <span>项目id：</span>
          <a-input v-model="projectId" placeholder="请输入" style="width:320px;" />
          <span @click="queryProject" style="width:80px;height:32px;line-height:32px;text-align:center;color:#fff;font-size:14px;border-radius:4px;cursor:pointer;background:rgba(34, 215, 187, 1);margin-left:16px;display:inline-block">查询</span>
        </div>
        <div>
          <div style="font-size:16px;color:rgba(51, 51, 51, 1);font-weight:bold;margin-top:45px">{{projectInfo.name}}</div>
          <div style="font-size:12px;color:rgba(170, 170, 170, 1);margin-top:16px">{{projectInfo.description}}</div>
        </div>
        <div v-if="projectInfo.status=='ENABLE'" style="margin-top:55px;text-align:center">
          <a-button type="primary" @click="createPro(projectId)">
            创建项目
          </a-button>
        </div>
      </div>
    </a-modal>
     <a-modal v-model="visibleTask" title="创建任务" :footer='null' :maskClosable='false' width='900px'>
      <div>
        <div style="color:rgba(51, 51, 51, 1);font-size:16px;">话句数量筛选</div>
        <div style="margin:24px 0">
          <span>选择条件：</span>
          <a-range-picker
            @change="changeTime"
            :placeholder="['开始时间','结束时间']"
            style="width:550px"
            :showTime="{
                hideDisabledOptions: true,
                defaultValue: [moment('00:00', 'HH:mm'), moment('23:59', 'HH:mm')],
            }"
            format="YYYY-MM-DD"
            :value="createValue"
          />
          <span @click="queryTaskWord" style="width:80px;height:32px;line-height:32px;text-align:center;display:inline-block;cursor:pointer;border-radius:4px;color:#fff;background:rgba(34, 215, 187, 1);margin:0 30px 0 16px">查询</span>
          <span v-if="ifShowTotal">
            <span style="color:rgba(153, 153, 153, 1);font-size:14px">总计：</span>
            <span style="color:rgba(34, 215, 187, 1);font-size:14px;">{{taskWordNum}}条</span>
          </span>
        </div>
        <div style="clear:both"></div>
        <div>
          <span style="float:left">交叉样本系数：</span>
          <a-slider id="test" :default-value="coefficient" @change='changeCoefficient' style="width:300px;display:inline-block;margin-top:20px;float:left;margin-top:6px"/>
          <span style="margin-left:24px">{{coefficient}}</span>
        </div>
        <div style="clear:both"></div>
        <div style="margin-top:16px">
          <a-upload
            name="file"
            :multiple="false"
            :customRequest="customRequest"
            @change="onUpload"
            ref="pathClear"
          >
            <a-button style="background:rgba(34, 215, 187, 1);color:#fff"> 
                <a-icon type="upload" />导入录音文件
            </a-button>
          </a-upload>
        </div>
        <a-divider />
        <div style="color:rgba(51, 51, 51, 1);font-size:16px;margin:8px 0 10px 0">选择意图</div>
        <div class="intention-list">
          <!-- <div>全选</div> -->
          <div v-for="(item, index) in intentionList" :key="index" @click="chooseIntention(index,item.id)" :class="{'active':intentionBoolList[index]}">
            <span>{{item.name}}</span>
            <span>{{item.sampleCount}}</span>
          </div>
        </div>
        <div style="color:rgba(51, 51, 51, 1);font-size:16px;margin:8px 0 10px 0">基本信息设定</div>
        <a-row>
          <a-col :span="12">
            <span>正确单价：</span>
            ￥<a-input-number style="margin:0 5px" v-model="priceObj.priceRight" :min="0"/>元
          </a-col>
          <a-col :span="12">
            <span>截止日期：</span>
            <a-date-picker
              format="YYYY-MM-DD"
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              :show-time="{ defaultValue: moment('00:00:00') }"
              placeholder='请选择时间'
              value=''
              v-model="deadline2"
              @change="changeEndTime2"
            />
          </a-col>
        </a-row>
        <a-row style="margin:16px 0">
          <a-col :span="12">
            <span>错误单价：</span>
            ￥<a-input-number style="margin:0 5px" v-model="priceObj.priceError" :min="-100"/>元
          </a-col>
          <a-col :span="12">
            <span>参与人数：</span>
            <a-input-number style="margin-right: 5px" v-model="userCount" :min="0"/>人
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <span>存疑单价：</span>
            ￥<a-input-number style="margin:0 5px" v-model="priceObj.priceDoubt" :min="0"/>元
          </a-col>
        </a-row>
        <div style="margin-top:16px;">
          <span>标注人员：</span>
          <a-select
            mode="multiple"
            :size="size"
            placeholder="请选择"
            :default-value="[]"
            style="width: 700px"
            @change="handleChange"
            @popupScroll="popupScroll"
          >
            <a-select-option v-for="(item, index) in userList" :value='item.id' :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
        <div style="text-align:center;margin-top:24px">
          <span @click="newTask" style="width:100px;height:32px;text-align:center;line-height:32px;cursor:pointer;display:inline-block;color:#fff;border-radius:4px;background:rgba(24, 144, 255, 1)">新建任务</span>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="visibleList" title="任务列表" :footer='null' :maskClosable='false' :width='1230'>
      <a-table :data-source="taskListData" :pagination='false' :loading="taskLoading">
        <a-table-column key="seriesNo" title="任务编号" data-index="seriesNo">
          <template slot-scope="text, record">
            <div>
              <span style="color:rgba(34, 215, 187, 1)">{{ record.seriesNo }}</span>
            </div>
          </template>
        </a-table-column>
        <a-table-column key="wordCount" title="话句数量" data-index="wordCount" />
        <a-table-column key="priceRight" title="正确单价" data-index="priceRight" />
        <a-table-column key="priceDoubt" title="存疑单价" data-index="priceDoubt" />
        <a-table-column key="priceError" title="错误单价" data-index="priceError" />
        <a-table-column key="applyUserCount" title="已申报人数/总人数" data-index="applyUserCount">
          <template slot-scope="text, record">
            <div>
              <span style="color:rgba(34, 215, 187, 1)">{{ record.applyUserCount+""+'/'+record.userCount }}</span>
            </div>
          </template>
        </a-table-column>
        <a-table-column key="limitDate" title="截止日期" data-index="limitDate" />
        <a-table-column key="id" title="操作" data-index="id">
          <template slot-scope="text, record">
            <div>
              <span style="color:rgba(34, 215, 187, 1);cursor:pointer" @click="viewDetail(record.id)">详情</span>
            </div>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
    <a-modal v-model="visibleDetail" title="任务详情" :footer='null' :maskClosable='false' width='1015px'>
      <div class="detail-modal">
        <div style="color:rgba(51, 51, 51, 1);font-size:16px;">只读字段</div>
        <a-row>
          <a-col :span="12">
            <span>查询时间段：</span>
            <span>{{taskDetail.startDate}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{taskDetail.endDate}}</span>
          </a-col>
          <a-col :span="12">
            <span>交叉样本数量：</span>
            <span>{{taskDetail.minSampleRate}}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <span>话句数量：</span>
            <span>{{taskDetail.wordCount}}条</span>
          </a-col>
          <a-col :span="12">
            <span>参与人数：</span>
            <span>{{taskDetail.userCount}}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <span>正确单价：</span>
            <span>￥{{taskDetail.priceRight}}</span>
          </a-col>
          <a-col :span="12">
            <span>存疑单价：</span>
            <span>￥{{taskDetail.priceDoubt}}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <span>错误单价：</span>
            <span>￥{{taskDetail.priceError}}</span>
          </a-col>
          <a-col :span="12">
            <span>任务状态：</span>
            <span>{{judgeState(taskDetail.status)}}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <span>指定标注人员：</span>
            <!-- <span>{{taskDetail.minSampleRate}}</span> -->
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <div style="display:flex;">
              <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">可选意图：</span>
              <div style="flex:1" class="intention-list2">
                  <div v-for="(item, index) in taskDetail.intentionNameList" :key="index">{{item}}</div>
              </div>
            </div>
          </a-col>
        </a-row>
        <div style="color:rgba(51, 51, 51, 1);font-size:16px;margin-top:24px">可编辑字段</div>
        <a-row>
          <a-col :span="12">
            <span style="height:32px;display:inline-block;line-height:32px;">截止日期：</span>
            <span v-if="!showDeadline">{{taskDetail.limitDate}}</span>
            <a-date-picker
              v-if="showDeadline"
              format="YYYY-MM-DD"
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              :show-time="{ defaultValue: moment('00:00:00') }"
              placeholder='请选择时间'
              v-model="deadline1"
              value=''
              @change="changeEndTime1"
            />
            <span v-if="taskState!='FINISH'">
              <span v-if="!showDeadline" @click="editTime('edit')" style="color:rgba(24, 144, 255, 1);font-size:14px;margin-left:24px;cursor:pointer">编辑</span>
              <span v-if="showDeadline" @click="editTime('save')" style="color:rgba(24, 144, 255, 1);font-size:14px;margin-left:24px;cursor:pointer">保存</span>
            </span>
            
          </a-col>
        </a-row>
        <a-divider />
        <div style="text-align:center">
          <span v-if="taskState=='TO_CHECK'" @click="backTo" style="width:100px;height:36px;display:inline-block;text-align:center;line-height:36px;border-radius:4px;cursor:pointer;color:#fff;background:rgba(24, 144, 255, 1);font-size:14px;">回滚</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script> 
import moment from 'moment';
export default {
  name: 'ProjectSquare',
  props: {
    msg: String
  },
   data() {
    return {
      visiblePro: false,
      projectInfo: {},
      visibleTask: false,
      dataTime: {
        startTime: '',
        endTime: ''
      },
      createValue: [],
      defaultTime: [],
      coefficient: 100,
      price: 0,
      size: 'default',
      deadline1: '',
      deadline2: '',
      visibleList: false,
      visibleDetail: false,
      showDeadline: false,
      data: '',
      ifShowLoading: false,
      currentPage: 1,
      pageSizeOptions: ['10', '20', '50', '100'],
      total: 0,
      pageSize: 10,
      taskLoading: false,
      projectId: '',
      taskListData: [],
      taskDetail: '',
      intentionList: [],
      intentionBoolList: [],
      userList: [],
      taskWordNum: 0,
      ifShowTotal: false,
      userCount: 0,
      priceObj: {
        priceRight: 0,
        priceError: 0,
        priceDoubt: 0
      },
      intentionIdList: [],
      taskId: '',
      taskState: '',
      defaultPersonList: [],
      txtData: ''
    }
  },
  methods: {
    moment,
    newProject() {
      this.visiblePro = true;
    },

    createPro(id) {
      this.visiblePro = false
      this.axios.post('/api/manager/project', {
        sassProjectId: id,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$parent.success('创建成功');
          this.queryData()
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    createTask(id) {
      this.projectId = id
      this.visibleTask = true
      this.queryIntentionList(id)
    },
    getCurrentDate(time) {
      let date = new Date(time)
      var year=date.getFullYear(); 
      var month=date.getMonth()+1; 
      var day=date.getDate(); 
      return year + '-' + (String(month).length > 1 ? month : '0' + month) + '-' + (String(day).length > 1 ? day : '0' + day)
    },
    changeCoefficient(value) {
      this.coefficient = value
    },
    handleChange(value) {
      this.defaultPersonList = value
    },
    popupScroll() {
      console.log('popupScroll');
    },
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledDate(current) {
      return current < moment().subtract(1, 'day');
    },
    disabledDateTime() {
      return {
        disabledHours: () => this.range(0, 24).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56],
      };
    },
    customRequest(data) {
      this.txtData = data.file
    },
    onUpload() {
      this.$refs.pathClear.value = ''
    },
    newTask() {
      let intentionIdStr = ''
      for(let i = 0; i < this.intentionIdList.length; i++){
        intentionIdStr = intentionIdStr + this.intentionIdList[i] + ","
      }
      intentionIdStr = intentionIdStr.substring(0,intentionIdStr.length-1)
      this.visibleTask = false
      const formData = new FormData() 
      formData.append('projectId', this.projectId)
      formData.append('startDate', this.dataTime.startTime)
      formData.append('endDate', this.dataTime.endTime)
      formData.append('mixSampleRate', this.coefficient)
      formData.append('intentionIdList', intentionIdStr)
      formData.append('priceRight', this.priceObj.priceRight)
      formData.append('priceError', this.priceObj.priceError)
      formData.append('priceDoubt', this.priceObj.priceDoubt)
      formData.append('userCount', this.userCount)
      formData.append('limitDate', this.deadline2)
      formData.append('userIdList', this.defaultPersonList)
      formData.append('file', this.txtData)
      this.axios({
        method: 'post',
        url: '/api/manager/project/task',
        headers:{
          'Content-Type':'application/x-www-form-urlencoded'
        },
        data: formData
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$parent.success('创建成功');
          this.queryData()
          this.defaultPersonList = []
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    changeEndTime1(date) {
      this.deadline1 = date.format("YYYY-MM-DD")
    },
    changeEndTime2(date) {
      this.deadline2 = date.format("YYYY-MM-DD")
    },
    viewList(id, state) {
      this.visibleList = true
      this.taskState = state
      this.axios({
        url: '/api/manager/project/task/list', 
        method: 'get',
        params: {
          projectId: id,
          status: state
        }
      })
      .then(response=> {
        if(response.data.code == 0){
          this.taskListData = response.data.data
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    viewDetail(id) {
      this.visibleList = false
      this.visibleDetail = true
      this.axios({
        url: '/api/manager/project/task', 
        method: 'get',
        params: {
          id: id,
        }
      })
      .then(response=> {
        if(response.data.code == 0){
            this.taskDetail = response.data.data
            this.taskId = id
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    editTime(type) {
      if(type == 'save'){
        this.axios.post('/api/manager/project/task/limitDate', {
          limitDate: this.deadline1,
          taskId: this.taskId
        })
        .then(response=> {
          if(response.data.code == 0){
            this.taskDetail.limitDate = this.deadline1
            this.showDeadline = !this.showDeadline
          }else{
            this.$parent.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }else{
        this.showDeadline = !this.showDeadline
      }
    },
    backTo() {
      this.axios.post('/api/manager/project/task/submit', {
        taskId: this.taskId
      })
      .then(response=> {
        this.visibleDetail = false
        if(response.data.code == 0){
          this.$parent.success('回滚成功');
          this.queryData()
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryData() {
      this.axios({
        url: '/api/manager/project/list', 
        method: 'get',
        params: {
          current: this.currentPage,
          size: this.pageSize
        }
      })
      .then(response=> {
        if(response.data.code == 0){
          this.data = response.data.data
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    onShowSizeChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize;
      this.queryData()
    },
    onChangeSample(value) {
      this.currentPage = value
      this.queryData()
    },
    queryProject() {
      this.axios({
        url: '/api/manager/project', 
        method: 'get',
        params: {
            sassProjectId: this.projectId,
        }
      })
      .then(response=> {
        if(response.data.code == 0){
            this.projectInfo = response.data.data
            if(this.projectInfo.status == 'NONE'){
              this.visiblePro = false
              this.$parent.error('请核对项目id');
            }else if(this.projectInfo.status == 'DISABLED'){
              this.visiblePro = false
              this.$parent.error('项目已创建');
            }
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    queryIntentionList(id) {
      this.axios({
        url: '/api/manager/intention/list', 
        method: 'get',
        params: {
            projectId: id,
        }
      })
      .then(response=> {
        if(response.data.code == 0){
            this.intentionBoolList = []
            this.intentionList = response.data.data
            this.intentionList.map(()=>{
              this.intentionBoolList.push(false)
            })
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    queryUserData() {
      this.axios({
        url: '/api/manager/dropdown/user', 
        method: 'get',
      })
      .then(response=> {
        if(response.data.code == 0){
          this.userList = response.data.data
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    changeTime(date, dateString) {
      this.createValue = date;
      this.dataTime.startTime = dateString[0]
      this.dataTime.endTime = dateString[1]
    },
    queryTaskWord() {
      this.axios({
        url: '/api/manager/taskWord/count', 
        method: 'get',
        params: {
            projectId: this.projectId,
            startDate: this.dataTime.startTime,
            endDate: this.dataTime.endTime
        }
      })
      .then(response=> {
        if(response.data.code == 0){
            this.ifShowTotal = true
            this.taskWordNum = response.data.data.wordCount
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    chooseIntention(index, id) {
      this.intentionBoolList[index] = !this.intentionBoolList[index]
      this.$forceUpdate()
      if(this.intentionBoolList[index]){
        this.intentionIdList.push(id)
      }else{
        for(let i = 0; i < this.intentionIdList.length; i++){
          if(this.intentionIdList[i] == id){
            this.intentionIdList.splice(i,1);
          }
        }
      }
    },
    judgeState(state) {
      switch(state) {
          case 'TO_START':
              return '待领取'
          case 'ON_GOING':
              return '进行中'
          case 'TO_CHECK':
              return '待验收'
          case 'FINISH':
              return '已完成'
          case 'DELAY':
              return '已延期'
      } 
    },
  },
  mounted: function() {
    this.dataTime.endTime = this.getCurrentDate(new Date().getTime())
    this.dataTime.startTime = this.getCurrentDate(new Date().getTime()-30*24*60*60*1000)
    this.defaultTime.push(this.dataTime.startTime)
    this.defaultTime.push(this.dataTime.endTime)
    this.queryData()
    this.queryUserData()
  }
}
</script>

<style lang="less">
  .project-square{
    padding: 24px;
    background: rgba(245, 246, 247, 1);
    .create-project{
      height: 64px;
      color: rgba(80, 80, 80, 1);
      background-color: rgba(255, 255, 255, 1);
      border-radius: 4px;
      font-size: 14px;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
      padding: 20px 24px;
      .title{
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
      }
      .new{
        width: 108px;
        height: 32px;
        background: rgba(34, 215, 187, 1);
        color: #fff;
        text-align: center;
        line-height: 32px;
        display: inline-block;
        border-radius: 4px;
        float: right;
        cursor: pointer;
      }
    }
    .project-list{
      margin-top: 16px;
      padding: 12px 0px;
      background:#fff;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      .title{
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        display: inline-block;
      }
      .condition-list{
        float: right;
        span{
          display:inline-block;
          padding: 0 19px 14px 19px;
          cursor: pointer;
        }
        span:nth-child(5){
          padding: 0 0px 14px 19px;
        }
        span:nth-child(5).active{
          padding: 0 19px 14px 19px;
        }
        span.active{
          color: rgba(24, 144, 255, 1);
          border-bottom: 3px solid rgba(24, 144, 255, 1);
        }
      }
      #pro-table{
        thead{
          display: none;
        }
      }
    }
  }
  .intention-list{
    div{
      display: inline-block;
      width: 200px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      border: 1px solid rgba(229, 229, 229, 1);
      cursor: pointer;
      border-radius: 4px;
      margin-right: 16px;
      color: rgba(80, 80, 80, 1);
      margin-bottom: 16px;
    }
    div:nth-child(4n){
      margin-right: 0px;
    }
    div.active{
      color: #fff;
      background: rgba(24, 144, 255, 1);
      border: 1px solid rgba(24, 144, 255, 1);
    }
  }
  .detail-modal{
    div.ant-row{
      margin-top: 24px;
    }
    div.ant-row div span:nth-child(1){
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
      display: inline-block;
      width: 100px;
    }
    div.ant-row div span:nth-child(2){
      color: rgba(80, 80, 80, 1);
      font-size: 14px;
      display: inline-block;
    }
  }
  .ant-modal-header{
    background: rgba(238, 238, 238, 1);
    height: 48px;
  }
  .intention-list2{
    div{
      display: inline-block;
      width: 200px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      border: 1px solid rgba(229, 229, 229, 1);
      border-radius: 4px;
      margin-right: 16px;
      color: rgba(80, 80, 80, 1);
      margin-bottom: 16px;
      background: rgba(229, 229, 229, 1);
      cursor: pointer;
    }
    div:nth-child(4n){
      margin-right: 0px;
    }
  }
</style>
